export default __webpack_public_path__ + "static/media/Virginia_Salas_Kastilio_AHV_In_Moms_We_Trust.9f4b3ab8.jpg";